// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const benefitsPet = {
  benefits_section_pet: {
    contentful_name: '[DEFAULT] Benefits Section - Pet',
    accident: '事故',
    illness: '疾病',
    wellness: '健康养生',
    header_accident_coverage: '仅限意外事故保障',
    header_accident_illness_coverage: '意外和疾病保障',
    header_wellness_coverage: '健康保障',
    header_enrollment_info: '注册信息',
    header_additional_info: '附加信息',
    covered_conditions: '承保条件：',
    info_accident_coverage: '此保障可帮助应对常见的宠物紧急情况,如骨折或吞食异物。',
    info_accident_illness_coverage: '此保障为上述所有项目提供福利,并为某些慢性病的持续治疗提供帮助。',
    info_wellness_coverage: '您的计划还包括常规护理保障,如体检和免疫接种。',
    info_wellness_buyup: '您还可以添加常规护理保障,例如体检和疫苗接种。',
    enrollment_period_label: '注册期',
    enrollment_period_only_oe: '仅在开放注册期间。',
    enrollment_period_anytime: '您可以随时注册。',
    enrollment_website_label: '注册网站',
    enrollment_website_text: '了解更多并注册。',
    cost_varies_tooltip: '您的保费取决于宠物的种类和品种、年龄以及您的居住地等因素。',
    annual_coverage_limit: '年度保障限额',
    annual_coverage_limit_tooltip: '这是您的计划在一年内承保的最高金额。',
    deductible_tooltip: '在保险开始承担部分费用之前,您需要自行支付的金额。',
  },
};
